import { http } from "./http";

// Stripe Connect onboarding and the Express dashboard link.
export const stripeApi = {
  /** Start (or resume) Connect onboarding; the server answers with where to send the talent. */
  connect: (fields: Record<string, unknown>) => http.post<{ url?: string }>("/stripe/connect", fields),
  dashboardLink: () => http.get<{ url: string }>("/stripe/dashboard"),
};
